import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { useLocation, useNavigate  } from 'react-router-dom';

const AccessTokenContext = createContext(null);

export const AccessTokenProvider = ({ children }) => {
  const [accessToken, setAccessToken] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const [, updateState] = useState();
const forceUpdate = useCallback(() => updateState({}), []);
  //const history = useHistory();

  useEffect(() => {
    forceUpdate();
    const params = new URLSearchParams(location.search);
    const token = params.get('access_token');
    if (token) {
      const cleanToken = token.replace(/ /g, "+");
      setAccessToken(cleanToken);
      const cleanUrl = location.pathname;
     navigate(cleanUrl)
    }
  }, [location.search,navigate]);

  return (
    <AccessTokenContext.Provider  value={{ accessToken }}>
      {children}
    </AccessTokenContext.Provider>
  );
};

export const useAccessToken = () => {
  return useContext(AccessTokenContext);
};
